export const errorTextGeneric = (when: string) =>
  `An error occurred while ${when}. Please try again or contact Megaphone support if issue persists.`;
export const errorTextRetry = (when: string) =>
  `There was a problem ${when}, please try again.`;
export const supportUrl = 'https://support.megaphone.fm/en/';
export const headerHeight = '54px';
